import { DataSourceList, DataSourceListOptions } from "@mecatran-components/datasourcelist"
import { StopTag } from "./stoptag.component.mjs";




export class StopList extends DataSourceList{
    constructor(stopListOptions){
        super(stopListOptions);


    }

    // ==========
    // private 
    // ----------


    // ==========
    // overload 
    // ----------
    createContainerNode(){
        var div = document.createElement('div');
        div.classList.add('stop-list');
        return div;
    }

    createItemComponent(stop){
        var stopTag = new StopTag(stop);
        stopTag.getDomNode().classList.add('selectable'); // selectable
        stopTag.getData = ()=>stop; // dataprovider
        return stopTag;
    }
    
 

    // ==========
    // public 
    // ----------
    /**
     * looks into the components with the function findComponents
     * @param findFn 
     */
     scrollTo(findFn){
        var storageManager = this.getStorageManager();
        var component = storageManager.findComponents('items',findFn);
        //component.setActive();
        var element = component.getDomManager().getDomNode();
        element.scrollIntoView({behavior:'smooth'});
    }

    findComponent(data1){
        return (component)=>{
            var data2 = component.getData();
            return (data1.getId() === data2.getId());
        }
    }

    activate(findFn){
        var storageManager = this.getStorageManager();
        var component = storageManager.findComponents('items',findFn);
        var element = component.getDomManager().getDomNode();  
        element.classList.add('active');      
    }

    deactivateAll(){
        var storageManager = this.getStorageManager();
        var components = storageManager.getComponents('items');
        components.forEach(component =>{ 
            var element = component.getDomManager().getDomNode();  
            element.classList.remove('active');  
        })        
    }

}



/**
 * StopListOptions extends DataSourceListOptions 
 */
 export class StopListOptions extends DataSourceListOptions{
    constructor(param){ super(param)}
}
